// src/components/ReviewModal.jsx
import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import API_BASE_URL from "../config";

const Smiley = ({ val, selected, onClick }) => {
  const titles = {
    1: "Very unhappy",
    2: "Unhappy",
    3: "Neutral",
    4: "Happy",
    5: "Very happy",
  };
  return (
    <div
      role="button"
      onClick={() => onClick(val)}
      title={`${val} - ${titles[val]}`}
      style={{
        fontSize: 28,
        padding: 8,
        cursor: "pointer",
        opacity: selected >= val ? 1 : 0.45,
      }}
    >
      {val === 1 && "😡"}
      {val === 2 && "😕"}
      {val === 3 && "😐"}
      {val === 4 && "🙂"}
      {val === 5 && "😄"}
    </div>
  );
};

export default function ReviewModal({ show, onHide, booking, onSaved }) {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const reset = () => {
    setRating(5);
    setComment("");
    setLoading(false);
  };

  const handleClose = () => {
    reset();
    onHide && onHide();
  };

  const handleSave = async () => {
    if (!rating || rating < 1 || rating > 5) {
      return Swal.fire("Validation", "Please select rating", "warning");
    }
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${API_BASE_URL}/bookings/${booking.id}/review`,
        { rating, comment },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setLoading(false);
      Swal.fire({ icon: "success", title: "Thanks!", text: "Review submitted." });
      onSaved && onSaved();
      handleClose();
    } catch (err) {
      setLoading(false);
      console.error(err);
      Swal.fire("Error", err.response?.data?.message || "Failed to submit review", "error");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Leave a review</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-center mb-3">
          {[1, 2, 3, 4, 5].map((v) => (
            <Smiley key={v} val={v} selected={rating} onClick={(val) => setRating(val)} />
          ))}
        </div>
        <Form.Group>
          <Form.Label>Comments (optional)</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Tell us about your experience..."
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={loading}>
          {loading ? "Saving..." : "Submit Review"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
